export const ARROW_DOWN = 9663;
export const ARROW_UP_FILLED = 9652;
export const ARROW_DOWN_FILLED = 9662;
export const CROSS = 10005;
export const RUPEE = 8377;
export const FULL_STOP = 46;
export const SINGLE_QOUTE = 39;
